import { doc, setDoc, onSnapshot } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react';
import { db } from '../firebase';
import { AuthContext } from './AuthContext';

export const SettingsContext = React.createContext();

export const SettingsProvider = ({ children }) => {
    const { user } = useContext(AuthContext);
    const [ settings, setSettings ] = useState({});

    useEffect(() => {
        if(user?.uid) {
            const unsub = onSnapshot(doc(db, "settings", user.uid), doc => 
                setSettings(doc.data())
            );

            return () => unsub();
        }
    }, [user?.uid]);

    const updateSetting = (key, value) => {
        setDoc(
            doc(db, "settings", user.uid),
            {
                ...settings,
                [key]: value
            }
        )
    };

    const getOrDefault = (key, defaultValue=true) => {
        return settings?.hasOwnProperty(key) ? settings[key] : defaultValue;
    };

    return (
        <SettingsContext.Provider value={{ 
            updateSetting,
            darkMode: settings?.darkMode,
            showClassFilter: getOrDefault('showClassFilter'),
            showSchoolFilter: getOrDefault('showSchoolFilter'),
            showLevelFilter: getOrDefault('showLevelFilter'),
            showSourceFilter: getOrDefault('showSourceFilter'),
            showComponentFilter: getOrDefault('showComponentFilter'),
            showTagsFilter: getOrDefault('showTagsFilter'),
            showDamageTypeFilter: getOrDefault('showDamageTypeFilter'),
            showSaveFilter: getOrDefault('showSaveFilter'),
            showAttackFilter: getOrDefault('showAttackFilter'),
            showCastingTimeFilter: getOrDefault('showCastingTimeFilter'),
            includeSubclasses: getOrDefault('includeSubclasses', false),
         }}>
             {children}
        </SettingsContext.Provider>
    );
};
